// @flow
import React, { Component } from 'react';
import { FormGroup, Label, Input, Popover, PopoverBody, InputGroup } from 'reactstrap';

import Counter from './Counter';

import withFlightSearchParams from '../../../HOCs/withFlightSearchParams';

import type { UpdateFlightSearchParms } from '../flowTypes';

type Props = {
  searchParams: {
    num_adults: number,
    num_children: number,
  },
  updateFlightSearchParms: UpdateFlightSearchParms,
};

type State = {
  popoverOpen: boolean,
};

class PassengerInput extends Component<Props, State> {
  state = {
    popoverOpen: false,
  };

  static defaultProps = {
    searchParams: {
      num_adults: 0,
      num_children: 0,
    },
  };

  render() {
    let { num_adults, num_children } = this.props.searchParams;
    return (
      <FormGroup className="col-12">
        <Label className="title">Passenger</Label>
        <InputGroup>
          <Input
            value={`${num_adults} adult, ${num_children} children`}
            onClick={this.togglePopover}
            id="Popover1"
            readOnly={true}
          />
        </InputGroup>
        <Popover
          placement="bottom"
          isOpen={this.state.popoverOpen}
          target="Popover1"
          toggle={this.togglePopover}
          style={{ minWidth: '276px' }}
        >
          <PopoverBody>
            <div className="clearfix" />
            <Counter
              title="Adults"
              count={num_adults}
              increment={this.handleAdultCount}
              decrement={this.handleAdultCount}
              key={'adults'}
            />
            <Counter
              title="Children (Under 12)"
              count={num_children}
              increment={this.handleChildrenCount}
              decrement={this.handleChildrenCount}
              key={'child'}
            />
          </PopoverBody>
        </Popover>
      </FormGroup>
    );
  }

  handleAdultCount = (count: number) => {
    if (count > 0) {
      this.props.updateFlightSearchParms({
        parameter: 'num_adults',
        value: count,
      });
    }
  };
  handleChildrenCount = (count: number) => {
    this.props.updateFlightSearchParms({
      parameter: 'num_children',
      value: count,
    });
  };
  togglePopover = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  };
}

export default withFlightSearchParams(PassengerInput);



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/PassengerInput.jsx